import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';

import App from "./screens/App";
import reportWebVitals from './utils/reportWebVitals';

// Import PrimeReact styles
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Import custom theme
import './theme/styles.css';

// Zustand store
import { useAppStore } from './store';

function Bootstrap() {
  React.useEffect(() => {
    // Start Firebase Auth -> Zustand sync once at app start
    const unsub = useAppStore.getState().common.auth.initAuthListener();
    return () => {
      // Optional: clean up on unmount (mostly for tests/hmr)
      try { useAppStore.getState().common.auth.teardownAuthListener(); } catch (_) {}
      if (typeof unsub === 'function') {
        try { unsub(); } catch (_) {}
      }
    };
  }, []);

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <PrimeReactProvider>
    <Bootstrap />
  </PrimeReactProvider>
);

reportWebVitals();
